module.exports = __webpack_public_path__ + "img/applet_qr.72f44e6c.jpg";